export const environment = {
    production: true,
    apiUrl: 'https://api.postotop.app.br',
    baseUrl: 'https://painel.postotop.app.br',
    appVersion: 'v1.3.0'
};



// WEBPACK FOOTER //
// ./src/environments/environment.ts